export const ACTIONS = {
  PTM_SLIDE_CHANGE_EVENT: 'PTM_SLIDE_CHANGE_EVENT',
  REINITIALIZE_PTM: 'REINITIALIZE_PTM',
  SET_RW_IMAGE_INDEX: 'SET_RW_IMAGE_INDEX',
  SET_SHOW_RW_IMAGE_MODAL: 'SET_SHOW_RW_IMAGE_MODAL',
  SET_SHOW_PTM_FEEDBACK_SIDE_MODAL: 'SET_SHOW_PTM_FEEDBACK_SIDE_MODAL',
  SET_SHOW_PTM_FEEDBACK_CENTER_MODAL: 'SET_SHOW_PTM_FEEDBACK_CENTER_MODAL',
  CLEAR_SHOW_PTM_FEEDBACK_SIDE_MODAL: 'CLEAR_SHOW_PTM_FEEDBACK_SIDE_MODAL',
};

export function ptmSlideChangeEventTriggered(payload) {
  return dispatch =>
    dispatch({
      type: ACTIONS.PTM_SLIDE_CHANGE_EVENT,
      payload,
    });
}

export const setRWImageIndex = payload => ({
  type: ACTIONS.SET_RW_IMAGE_INDEX,
  payload,
});

export const setShowRWImageModal = payload => ({
  type: ACTIONS.SET_SHOW_RW_IMAGE_MODAL,
  payload,
});

export const reinitializePtm = payload => ({
  type: ACTIONS.REINITIALIZE_PTM,
  payload,
});

export const setShowPTMFeedbackSideModal = payload => ({
  type: ACTIONS.SET_SHOW_PTM_FEEDBACK_SIDE_MODAL,
  payload,
});

export const clearShowPTMFeedbackSideModal = () => ({
  type: ACTIONS.CLEAR_SHOW_PTM_FEEDBACK_SIDE_MODAL,
});
